<template>
  <el-dialog
    :title="$t('room.addFloor.title')"
    :visible.sync="visible"
    width="50%"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item :label="$t('room.addFloor.floorNum')" prop="floorNum">
        <el-input v-model="form.floorNum" :placeholder="$t('room.addFloor.floorNumPlaceholder')" />
      </el-form-item>
      
      <el-form-item :label="$t('room.addFloor.name')" prop="name">
        <el-input v-model="form.name" :placeholder="$t('room.addFloor.namePlaceholder')" />
      </el-form-item>
      
      <el-form-item :label="$t('room.addFloor.floorArea')" prop="floorArea">
        <el-input v-model="form.floorArea" :placeholder="$t('room.addFloor.floorAreaPlaceholder')">
          <template slot="append">m²</template>
        </el-input>
      </el-form-item>
      
      <el-form-item :label="$t('room.addFloor.seq')" class="text-left" prop="seq">
        <el-input-number v-model="form.seq" :min="1" />
      </el-form-item>
      
      <el-form-item :label="$t('room.addFloor.remark')" prop="remark">
        <el-input v-model="form.remark" type="textarea" :placeholder="$t('room.addFloor.remarkPlaceholder')" />
      </el-form-item>
      
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSave">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addFloor } from '@/api/room/addFloorApi'

export default {
  name: 'AddFloor',
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    console.log('AddFloor组件初始化 - data方法')
    return {
      visible: false,
      form: {
        communityId: '',
        floorNum: '',
        name: '',
        floorArea: '',
        seq: 1,
        remark: ''
      },
      errorInfo: '',
      rules: {
        floorNum: [
          { required: true, message: this.$t('room.addFloor.floorNumRequired'), trigger: 'blur' },
          { min: 1, max: 64, message: this.$t('room.addFloor.floorNumLength'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('room.addFloor.nameRequired'), trigger: 'blur' },
          { min: 2, max: 64, message: this.$t('room.addFloor.nameLength'), trigger: 'blur' }
        ],
        floorArea: [
          { required: true, message: this.$t('room.addFloor.floorAreaRequired'), trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: this.$t('room.addFloor.floorAreaFormat'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('room.addFloor.seqRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('room.addFloor.seqNumber'), trigger: 'blur' }
        ],
        remark: [
          { max: 200, message: this.$t('room.addFloor.remarkMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    console.log('AddFloor组件 - created生命周期')
    console.log('AddFloor组件 - getCommunityId方法是否存在:', typeof this.getCommunityId === 'function')
    if (typeof this.getCommunityId === 'function') {
      console.log('AddFloor组件 - getCommunityId返回值:', this.getCommunityId())
    }
  },
  watch: {
    'form.floorNum': function(newVal) {
      console.log('AddFloor组件 - floorNum变化:', newVal)
      if (newVal) {
        this.form.name = `${newVal}${this.$t('room.addFloor.buildingSuffix')}`
        console.log('AddFloor组件 - 自动生成name:', this.form.name)
      } else {
        this.form.name = ''
        console.log('AddFloor组件 - 清空name')
      }
    }
  },
  methods: {
    open() {
      console.log('AddFloor组件 - 打开对话框')
      this.visible = true
      this.resetForm()
      console.log('AddFloor组件 - 对话框打开后form数据:', this.form)
    },
    handleClose() {
      console.log('AddFloor组件 - 关闭对话框')
      this.visible = false
      this.resetForm()
    },
    resetForm() {
      console.log('AddFloor组件 - 重置表单')
      const communityId = this.getCommunityId()
      console.log('AddFloor组件 - 重置时getCommunityId返回值:', communityId)
      this.form = {
        communityId: communityId,
        floorNum: '',
        name: '',
        floorArea: '',
        seq: 1,
        remark: ''
      }
      this.errorInfo = ''
      if (this.$refs.form) {
        this.$refs.form.resetFields()
        console.log('AddFloor组件 - 表单字段已重置')
      }
      console.log('AddFloor组件 - 重置后form数据:', this.form)
    },
    async handleSave() {
      console.log('AddFloor组件 - 开始保存操作')
      console.log('AddFloor组件 - 保存前form数据:', this.form)
      
      this.$refs.form.validate(async (valid) => {
        console.log('AddFloor组件 - 表单验证结果:', valid)
        if (!valid) {
          console.log('AddFloor组件 - 表单验证失败，终止保存')
          return
        }
        
        try {
          // 确保communityId被正确设置
          const communityId = this.getCommunityId()
          console.log('AddFloor组件 - 保存时getCommunityId返回值:', communityId)
          this.form.communityId = communityId
          
          console.log('AddFloor组件 - 准备发送的请求参数:', this.form)
          console.log('AddFloor组件 - addFloor API是否存在:', typeof addFloor === 'function')
          
          if (typeof addFloor !== 'function') {
            console.error('AddFloor组件 - addFloor API未定义')
            this.errorInfo = 'API方法未定义'
            return
          }
          
          console.log('AddFloor组件 - 开始调用addFloor API')
          const response = await addFloor(this.form)
          console.log('AddFloor组件 - addFloor API调用完成，响应:', response)
          
          if (response && response.code == 0) {
            const successMsg = this.$t('common.operationSuccess')
            console.log('AddFloor组件 - 添加楼栋成功，显示toast:', successMsg)
            this.$message.success(successMsg)
            this.handleClose()
            this.$emit('handleRefreshTree', {})
          } else {
            const errorMsg = response && response.msg || this.$t('room.addFloor.saveFailed')
            this.errorInfo = errorMsg
            this.$message.error(errorMsg)
            console.error('AddFloor组件 - 添加楼栋失败，显示toast:', errorMsg, response)
          }
        } catch (error) {
          console.error('AddFloor组件 - 添加楼栋异常:', error)
          console.error('AddFloor组件 - 异常详情:', error.message, error.stack)
          console.error('AddFloor组件 - 错误响应:', error.response)
          
          // 尝试从错误响应中提取具体错误信息
          let errorMsg = this.$t('room.addFloor.saveError')
          if (error.response && error.response.data) {
            const errorData = error.response.data
            console.log('AddFloor组件 - 错误响应数据:', errorData)
            if (errorData.msg) {
              errorMsg = errorData.msg
              console.log('AddFloor组件 - 从响应中提取错误信息:', errorMsg)
            }
          }
          
          // 设置错误信息并通过toast提示
          this.errorInfo = errorMsg
          this.$message.error(errorMsg)
          console.log('AddFloor组件 - 显示错误toast:', errorMsg)
        }
      })
    },
  }
}
</script>